__turbopack_context__.v({
  "container": "AdvancedPricingTag-module-scss-module__2Y4PFG__container",
});
